import axios from "axios";
import API from "../helpers/api";
let searchData = {
  ServiceProviderName: "",
  PageNumber: 1,
  PageSize: 20,
};
export const getServiceProviderList = (item) => {
  let url = `${API.getServiceProviderList}?ServiceProviderName=${item.ServiceProviderName}&port=${item.port}&country=${item.country}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getServiceProviderListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getServiceProviderListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPortAndCountry = (item) => {
  item.port = item.port ?? "";
  item.country = item.country ?? "";

  let url = `${API.portAndCountry}?portName=${item.port}&CountryName=${item.country}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if (item.port === "") {
          dispatch({
            type: "getPortListsSuccess",
            data: response.data,
          });
        }
        dispatch({
          type: "getPortAndCountrySuccess",
          data: response.data,
        });
        if (item.country === "") {
          let chars = [];
          var processed = response.data.map((i, index) =>
            chars.push(i.country)
          );
          let result = chars.filter(
            (item, index) => chars.indexOf(item) === index
          );
          console.log(chars);
          console.log(result);
          dispatch({
            type: "getVendorCountryListSuccess",
            data: result,
          });
          dispatch({
            type: "getCountryListSuccess",
            data: response.data,
          });
        }

        dispatch({
          type: "getServiceProviderPortListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPortAndCountryFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipPortAndCountry = (item) => {
  item.port = item.port ?? "";
  item.country = item.country ?? "";
  item.serviceProvider = item.serviceProvider ?? "";

  let url = `${API.serviceProviderPortAndCountry}?portName=${encodeURIComponent(item.port)}&CountryName=${encodeURIComponent(item.country)}&serviceProvider=${encodeURIComponent(item.serviceProvider)}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let getData = {
          type: item.type,
          data: response.data,
        };
        if (item.port === "") {
          let thing = response.data.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.port === thing.port &&
                  t.port !== null &&
                  thing.port !== null
              )
          );
          let getData1 = {
            type: item.type,
            data: thing,
          };
          dispatch({
            type: "getShipPortListSuccess",
            data: getData1,
          });
        }
        if (item.country === "") {
          let thing = response.data.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.country === thing.country &&
                  t.country !== null &&
                  thing.country !== null
              )
          );
          let getData2 = {
            type: item.type,
            data: thing,
          };
          dispatch({
            type: "getShipCountryListSuccess",
            data: getData2,
          });
        }
        if (item.serviceProvider === "") {
          let thing = response.data.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.serviceProvider === thing.serviceProvider &&
                  t.serviceProvider !== null &&
                  thing.serviceProvider !== null
              )
          );
          let getData3 = {
            type: item.type,
            data: thing,
          };
          dispatch({
            type: "getShipServiceProviderPortListSuccess",
            data: getData3,
          });
        }
        // if (item.serviceProvider === "") {
        //   dispatch({
        //     type: "getShipServiceProviderPortListSuccess",
        //     data: getData,
        //   });
        // }
        if (item.serviceProvider && item.country && item.port) {
          dispatch({
            type: "getShipServiceProviderIDSuccess",
            data: getData,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "getShipPortAndCountryFailure",
          error: "ERROR",
        });
      });
  };
};
export const getAllShipPortAndCountry = () => {
  let item = {
    port: "",
    country: "",
    serviceProvider: "",
  };

  let url = `${API.serviceProviderPortAndCountry}?portName=${item.port}&CountryName=${item.country}&serviceProvider=${item.serviceProvider}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let getData = {
          type: item.type,
          data: response.data,
        };
        if (item.port === "") {
          let thing = response.data.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.port === thing.port &&
                  t.port !== null &&
                  thing.port !== null
              )
          );
          let getData1 = {
            type: item.type,
            data: thing,
          };
          dispatch({
            type: "getAllShipPortListSuccess",
            data: thing,
          });
        }
        if (item.country === "") {
          let thing1 = response.data.filter(
            (thing1, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.country === thing1.country &&
                  t.country !== null &&
                  thing1.country !== null
              )
          );
          // let getData2 = {
          //   type: item.type,
          //   data: thing,
          // };
          dispatch({
            type: "getAllShipCountryListSuccess",
            data: thing1,
          });
        }
        if (item.serviceProvider === "") {
          let thing3 = response.data.filter(
            (thing3, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.serviceProvider === thing3.serviceProvider &&
                  t.serviceProvider !== null &&
                  thing3.serviceProvider !== null
              )
          );
          // let getData3 = {
          //   type: item.type,
          //   data: thing,
          // };
          dispatch({
            type: "getAllShipServiceProviderPortListSuccess",
            data: thing3,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "getShipPortAndCountryFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPortCountry = (item) => {
  let url = `${API.portAndCountry}?portName=${item.port}&CountryName=${item.country}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPortCountrySuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPortCountryFailure",
          error: "ERROR",
        });
      });
  };
};

export const postServiceProviderDetails = (data) => {
  let url = `${API.postServiceProvider}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch(getServiceProviderList(searchData));
        dispatch({
          type: "postServiceProviderDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postServiceProviderDetailFailure",
          error: "ERROR",
        });
      });
  };
};
export const putServiceProviderDetails = (data) => {
  let url = `${API.postServiceProvider}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch(getServiceProviderList(searchData));
        dispatch({
          type: "putServiceProviderDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putServiceProviderDetailFailure",
          error: "ERROR",
        });
      });
  };
};
export const deleteServiceProviderDetails = (data) => {
  let url = `${API.postServiceProvider}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch(getServiceProviderList(searchData));
        dispatch({
          type: "deleteServiceProviderDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "deleteServiceProviderDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getAdhocAnalysisData = (data) => {
 
  let url = `${API.adhocGet}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postAdhocAnalysisSuccess",
          data: response,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postAdhocAnalysisFailure",
          error: "ERROR",
        });
      });
  };
};


export const DownloadExcelReport = (data) => {
  let url = `${API.downloadExcel}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        console.log(response);
        
        // dispatch({
        //   type: "postAdhocAnalysisSuccess",
        //   data: response,
        // });
      })
      .catch((error) => {
        dispatch({
          type: "postAdhocAnalysisFailure",
          error: "ERROR",
        });
      });
  };
};